import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ themeName, palette, mlbCustomVariables }) => ({
  legalText: {
    fontFamily: mlbCustomVariables.primaryFont,
    color: palette.common.marketingText,
    ...(themeName === 'dacia' && {
      fontSize: 12,
      fontFamily: 'Read',
      color: palette.common.black
    })
  }
}));
